"use strict";
var vec3 = require('gl-matrix/src/gl-matrix/vec3');
var _v0 = vec3.create();
var _v1 = vec3.create();
var _v2 = vec3.create();
var RaycastCollisionDetector3D = (function () {
    function RaycastCollisionDetector3D(raycast) {
        this.raycast = raycast;
    }
    RaycastCollisionDetector3D.prototype.collides = function (ray) {
        return this.findCollision(null, ray);
    };
    RaycastCollisionDetector3D.prototype.findCollision = function (outputCollision, inputRay) {
        var direction = vec3.sub(_v0, inputRay.end.data, inputRay.start.data);
        var maxDistance = vec3.len(direction);
        if (maxDistance === 0)
            return false;
        var hitPos = _v1;
        var hitNormal = _v2;
        var result = this.raycast(inputRay.start.data, direction, maxDistance, hitPos, hitNormal);
        if (!result)
            return false;
        if (outputCollision != null) {
            vec3.copy(outputCollision.point.data, hitPos);
            vec3.copy(outputCollision.normal.data, hitNormal);
        }
        return true;
    };
    return RaycastCollisionDetector3D;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = RaycastCollisionDetector3D;
//# sourceMappingURL=RaycastCollisionDetector3D.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/engine/lib/controls/CommandControl/commands/RaycastCollisionDetector3D.js
 ** module id = 930
 ** module chunks = 0
 **/